import { Container, Row, Col } from "react-bootstrap";
import { usePrefersReducedMotion } from '../lib/usePrefersReducedMotion';
import TrackVisibility from 'react-on-screen';
import 'animate.css';

const cases = [
  {
    title: "Sackatoga Stable",
    meta: "Thoroughbred Racing Syndicate · $12,000",
    challenge: "Home of Kentucky Derby winner Funny Cide and Belmont Stakes winner Tiz the Law — running a Wix site that couldn't keep up with race results, horse profiles, or ownership communication. Email broken between two registrar accounts. Nothing searchable.",
    build: "Complete custom WordPress + Divi rebuild with the StableSite system. 75+ proprietary shortcodes. Horse profile custom post types. Auto-calculating career stats. Equibase PDF-to-database race result pipeline. Ownership, philanthropy, news, and merchandise sections.",
    result: "All horse shares sold out at launch.",
    resultStatus: "shipped"
  },
  {
    title: "Full Circle Fitness",
    meta: "Boutique Fitness Studio · WordPress + Divi 5 + PushPress",
    challenge: "An aging WordPress site that didn't reflect the studio's coaching brand, didn't integrate with their PushPress member management platform, and wasn't capturing leads from the people walking by their door every day.",
    build: "Complete Divi 5 rebuild with PushPress integration, modernized branding, mobile-first design, and conversion-focused class signup flows.",
    result: "Launching this week — results to follow.",
    resultStatus: "pending"
  },
  {
    title: "FTR Trucking + HaulDesk",
    meta: "Owner-Operator Logistics · Custom SaaS",
    challenge: "A startup trucking outfit drowning in driver coordination, broker paperwork, POD photos coming in over text, and invoice mismatches. No web presence — and brokers were checking before booking loads.",
    build: "Phase 1: a clean landing page to establish web presence. Phase 2: HaulDesk — a custom SaaS platform purpose-built for small fleets and owner-operators. Drivers, loads, brokers, PODs, invoices, compliance — one tool, built on Next.js + Supabase + Stripe.",
    result: "HaulDesk MVP in active development with FTR as launch customer. Reseller partnerships in motion.",
    resultStatus: "shipped"
  }
];

export const CaseStudies = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <section className="case-studies" id="projects" aria-labelledby="case-studies-heading">
      <Container>
        <Row>
          <Col>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div className={`case-studies-intro ${prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeIn" : "pre-reveal")}`}>
                  <h2 id="case-studies-heading">Recent builds.</h2>
                  <p className="case-studies-subhead">Real businesses. Real problems. Real systems.</p>
                </div>
              )}
            </TrackVisibility>

            <Row className="case-studies-grid">
              {cases.map((c, i) => (
                <Col xs={12} lg={4} key={c.title} className="case-col">
                  <TrackVisibility once>
                    {({ isVisible }) => (
                      <article className={`case-card ${prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeInUp" : "pre-reveal")}`} style={{ animationDelay: `${i * 100}ms` }}>
                        <header className="case-header">
                          <h3>{c.title}</h3>
                          <p className="case-meta">{c.meta}</p>
                        </header>

                        <dl className="case-body">
                          <dt>The challenge</dt>
                          <dd>{c.challenge}</dd>

                          <dt>The build</dt>
                          <dd>{c.build}</dd>

                          <dt>The result</dt>
                          <dd className={`case-result ${c.resultStatus === 'pending' ? 'case-result-pending' : ''}`}>
                            {c.result}
                          </dd>
                        </dl>
                      </article>
                    )}
                  </TrackVisibility>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
